export { FaqPageSlice } from './FaqPageSlice'
export { TermsPageSlice } from './TermsPageSlice'
export { PrivacyPolicySlice } from './PrivacySlice'
export { RefundPolicySlice } from './RefundPolicySlice'
